import React from 'react';
import { useAuth } from '@fourthwall/auth';
import { Button } from '@fourthwall/components';
import { useSendVerifyEmailMutation } from '../../../../../../hooks/useSendVerifyEmailMutation';
export const ResendVerificationEmailButton = ({ onClick, label = 'Resend email', size = 'xsmall', appearance = 'secondary', ...buttonProps }) => {
    const { user, keycloak } = useAuth();
    const { sendVerifyEmailMutation } = useSendVerifyEmailMutation();
    const isVerified = user?.verified || keycloak?.tokenParsed?.email_verified;
    const handleClick = () => {
        sendVerifyEmailMutation.mutate();
        onClick?.();
    };
    if (isVerified) {
        return null;
    }
    return (React.createElement(Button, { ...buttonProps, label: label, size: size, appearance: appearance, onClick: handleClick }));
};
